export class Composer {
    id!: number;
    name!: string;

    static fromObject(obj: Record<string, any>): Composer {
        return Object.setPrototypeOf(obj, Composer.prototype);
    }
}
